import { GetterTree } from "vuex";
import { IContentProviderState } from ".";
import { IRootState } from "@/store/types";
import { IContentProvider } from "@/models/contentprovider";

export const getters: GetterTree<IContentProviderState, IRootState> = {
    serviceProvidersList(state): IContentProvider[] | null {
        return state.contentProvidersList;
    },
    selectedContentProvider(state): IContentProvider | null {
        return state.selectedContentProvider;
    },
    isSelectedContentProvider(state): boolean {
        return state.isSelectedContentProvider;
    },
};
